import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import App from './App.tsx';
import { ConsentPage } from './components/ConsentPage.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { LegalAcceptanceGate } from './components/LegalAcceptanceGate.tsx';
import './index.css';

const path = window.location.pathname;
const consentMatch = path.match(/^\/consent\/([^/]+)$/);

if (consentMatch) {
  const token = consentMatch[1];
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <ConsentPage token={token} />
      </ErrorBoundary>
    </StrictMode>
  );
} else if (path === '/authorize') {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <ConsentPage token={token} />
      </ErrorBoundary>
    </StrictMode>
  );
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <AuthProvider>
          <App />
          <LegalAcceptanceGate />
        </AuthProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}
